import { render, staticRenderFns } from "./ideaHandle.vue?vue&type=template&id=304cbb05&scoped=true&"
import script from "./ideaHandle.vue?vue&type=script&lang=js&"
export * from "./ideaHandle.vue?vue&type=script&lang=js&"
import style0 from "./ideaHandle.vue?vue&type=style&index=0&id=304cbb05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304cbb05",
  null
  
)

export default component.exports